//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HButton from '../HButton'
import Wrapper from './Wrapper'
import {prefix} from '../../common/mixins'

export default {
  name: 'Prompt',
  components: {
    HButton,
    Wrapper,
  },
  mixins: [prefix],
  /* eslint-disable vue/require-default-prop */
  props: {
    title: String,
    content: String,
    noMask: Boolean,
    placeholder: {
      type: String,
      default: '',
    },
    buttons: {
      type: Array,
      default: () => [
        {
          type: 'cancel',
          text: '取消',
          color: '',
          bgColor: '',
          alone: false,
        },
        {
          type: 'confirm',
          text: '确定',
          color: '',
          bgColor: '',
          alone: false,
        },
      ],
    },
  },
  /* eslint-enable */
  data () {
    return {
      show: false,
      inputValue: '',
    }
  },
  computed: {
    firstButtonClass () {
      return this.buttons[0].alone ? 'alone half' : ''
    },
    secondButtonClass () {
      return this.buttons[1].alone ? 'alone half' : ''
    },
    firstButtonStyle () {
      return {
        color: this.buttons[0].color,
        backgroundColor: this.buttons[0].bgColor,
      }
    },
    secondButtonStyle () {
      return {
        color: this.buttons[1].color,
        backgroundColor: this.buttons[1].bgColor,
      }
    },
  },
  watch: {
    show (val) {
      if(val) {
        // 每次显示时将input中的内容设置为content中的值
        // 如果content值为空，表示重置input内容
        this.$refs.input.textContent = this.content
        this.inputValue = this.content
        setTimeout(() => {
          if(this.$refs.input) {
            this.setInputFocus()
            if(this.content) {
              // 以下代码用来修正光标位置，否则光标会出现在文字前面
              const range = document.createRange()
              const node = this.$refs.input.childNodes[0]
              range.selectNodeContents(node)
              range.collapse(false) // 通过参数来控制光标的位置，true表示在文字前面，false表示在文字后面
              const selection = window.getSelection()
              selection.removeAllRanges()
              selection.addRange(range)
            }
          }
        }, 300)
      }
    },
  },
  methods: {
    setInputFocus () {
      this.$refs.input.focus()
    },
    setInputValue (val) {
      this.inputValue = val.trim()
    },
    click (type, index) {
      // 如果type未指定，根据索引来确定点击的是取消还是确认按钮
      // 默认取消按钮放置在前，索引为0，确认按钮放置在后，索引为1
      if(!type) {
        if(index) {
          this.confirm()
        } else {
          this.cancel()
        }
      } else if(type === 'confirm') {
        this.confirm()
      } else {
        this.cancel()
      }
    },
    cancel () {
      if(!this.show) return
      this.$emit('on-cancel')
      this.hide()
    },
    confirm () {
      if(!this.show) return
      this.$emit('on-confirm', this.inputValue)
      this.hide()
    },
    hide () {
      this.show = false
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Dialog/Prompt.vue